<template>
  <div class="routePlanningEchartContainer">
    <div id="routePlanningEchart"></div>
  </div>
</template>

<script type="text/javascript">
import * as echarts from "echarts";
import * as olSphere from "ol/sphere";

export default {
  name: "RoutePlanningEchart",
  data() {
    return {
      echart: null,
    };
  },
  props: ["routeList"],
  methods: {
    renderChart() {
      let echart = this.$data.echart;
      if (null == echart) {
        var chartDom = document.getElementById("routePlanningEchart");
        echart = this.$data.echart = echarts.init(chartDom);
      }

      const datas = this.getRenderData();

      var option;
      option = {
        grid: { top: 57, right: 88, bottom: 40, left: 63 },
        xAxis: {
          name: "距离(km)",
          min: 0, //最小刻度
          max: datas.maxXaxis, //最大刻度
          interval: datas.maxXaxis / 5, //  平均分为5份
          nameTextStyle: { color: "#FFA63E" },
          axisLabel: { color: "#FFFFFF" },
          splitLine: { show: false },
          axisLine: { lineStyle: { color: "#FFFFFF" } },
          axisTick: { show: false },
          type: "value",
        },
        yAxis: {
          name: "高度(m)",
          min: 0,
          max: datas.maxYaxis,
          interval: datas.maxYaxis / 5, //  平均分为5份
          nameTextStyle: { color: "#FFA63E" },
          axisLabel: { color: "#FFFFFF" },
          splitLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } },
          axisLine: { lineStyle: { color: "#FFFFFF" } },
          axisTick: { show: false },
          type: "value",
        },
        series: [
          {
            data: datas.data,
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 7,
            itemStyle: {
              color: "#1D273C",
              borderWidth: 2,
              borderType: "solid",
              borderColor: "#FFA63E",
            },
            lineStyle: { color: "#FFA63E" },
          },
        ],
      };

      echart.setOption(option);
    },
    getRenderData() {
      const routeList = this.routeList;
      const data = { xAxis: [], yAxis: [], data: [] };
      let length = 0;
      let height = 0;
      for (let index = 0; index < routeList.length; index++) {
        const element0 = routeList[index];
        if (0 < index) {
          const element1 = routeList[index - 1];
          length += olSphere.getDistance(
            [element0.lon, element0.lat],
            [element1.lon, element1.lat]
          );
        }
        if (height < element0.alt) {
          height = element0.alt;
        }
        data.data.push([length / 1000, element0.alt]);
      }
      data.maxXaxis = Math.ceil(length / 1000 / 100) * 100;
      data.maxYaxis = Math.ceil(height / 500) * 500;
      return data;
    },
  },
  watch: {
    routeList(nval, oval) {
      this.renderChart();
    },
  },
};
</script>
<style>
.routePlanningEchartContainer {
  width: 734px;
  height: 328px;
  background: rgba(28, 35, 64, 0.9);
  border: 1px solid #0083fd;
  border-radius: 6px;
  position: absolute;
  left: 38px;
  bottom: 325px;
}
#routePlanningEchart {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningEchart.vue